/**
 * FlashlightSection — composes FlashlightCards into a panel.
 *
 * Replaces the legacy FlashlightPanel inside EquipmentPanel.tsx.
 */
import { PanelSection } from '../ui'
import { useDesktopStore } from '../../stores/desktop'
import { markDirty } from '../../stores/sync'
import type { Flashlight } from '../../stores/desktop'
import FlashlightCard from './FlashlightCard'

export default function FlashlightSection() {
  const { flashlights, setFlashlights } = useDesktopStore()

  function update(id: number, patch: Partial<Flashlight>) {
    markDirty()
    setFlashlights(flashlights.map(f => (f.id === id ? { ...f, ...patch } : f)))
  }

  return (
    <PanelSection title="Flashlights" marginBottom={0}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
        {flashlights.map(f => (
          <FlashlightCard key={f.id} f={f} onUpdate={patch => update(f.id, patch)} />
        ))}
      </div>
    </PanelSection>
  )
}
